module.exports = __webpack_public_path__ + "static/img/aboutUsImg1.3507c06b.png";